import { httpClient } from "@services/api/httpClient";

const generateTechnicalAssessment = async (id: number) => {
    const response = await httpClient.post(`/offer-technical-assesment/manual-generate`, { offerId: id });
    return response.data;
}

export default generateTechnicalAssessment;